/**
 * @file SEO.jsx
 * @description Gestión de metadatos, SEO técnico (JSON-LD) e identidad visual (Favicon).
 * @author JEMAprod-Tecnologia (2026)
 */

import { Helmet } from 'react-helmet-async';
import data from "../data/content.json";
import { DEFAULT_OG_IMAGE } from "../config/seoRoutes";

const SEO = ({ 
  title = "AGDYSA | Inteligencia en Salud Laboral e Higiene Industrial",
  description = "Especialistas en medicina del trabajo, higiene industrial y laboratorio acreditado. Protegemos el futuro de la industria con ciencia aplicada.",
  keywords = "salud ocupacional, higiene industrial, laboratorio clínico, prevención de riesgos, estrés térmico, OSA",
  ogImage = DEFAULT_OG_IMAGE,
  url = "https://agdysa.com"
}) => {

  // Definición del Logo desde el contenedor para consistencia de marca
  const brandLogo = data.logos.agdysa_logo;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "AGDYSA",
    "url": url,
    "logo": brandLogo,
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "SV" // Corregido a El Salvador según contexto previo
    },
    "service": [
      "Monitoreo de Estrés Térmico",
      "Laboratorio Clínico Ocupacional",
      "Higiene Industrial"
    ]
  };

  return (
    <Helmet>
      {/* Metadatos Básicos */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* --- IDENTIDAD VISUAL (FAVICON) --- */}
      {/* Ícono estándar para navegadores */}
      <link rel="icon" type="image/png" href={brandLogo} />
      {/* Ícono para dispositivos Apple (Home Screen) */}
      <link rel="apple-touch-icon" href={brandLogo} />
      {/* Ícono para pestañas de Android / Chrome */}
      <link rel="shortcut icon" href={brandLogo} />

      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Inyección de JSON-LD para Google (SEO Técnico) */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};


export default SEO;